module.exports = __webpack_public_path__ + "static/image/service/m/robot2.ver2_0_2.jpg?5eaf1b98";